module.exports = __webpack_public_path__ + "static/media/cedar_logo.50d4decf.png";